import { getQuery, insertQuery, updateQuery, deleteQuery } from "./PaymentgatewayWrapper.js";

const attachPaymentMethod = async (payment_method_id, customer_id) => {
  try {
    const data = JSON.stringify({
      query: `mutation AttachPaymentMethod($paymentMethodId: String!, $customerId: String!) {
  attachPaymentMethod(payment_method_id: $paymentMethodId, customer_id: $customerId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { paymentMethodId: payment_method_id, customerId: customer_id }
    });

    const response = await insertQuery(data);
    return response?.attachPaymentMethod;
  } catch (error) {
    console.log(error);
  }
};

const geCustomerPaymentMethods = async (customer_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetCustomerPaymentMethods($customerId: String!) {
  getCustomerPaymentMethods(customer_id: $customerId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        customerId: customer_id
      }
    });

    const response = await getQuery(data);
    return response?.getCustomerPaymentMethods;
  } catch (error) {
    console.log(error);
  }
};

const detachPaymentMethod = async (payment_method_id, customer_id) => {
  try {
    const data = JSON.stringify({
      query: `mutation DetachPaymentMethod($paymentMethodId: String!, $customerId: String!) {
  detachPaymentMethod(payment_method_id: $paymentMethodId, customer_id: $customerId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        paymentMethodId: payment_method_id,
        customerId: customer_id
      }
    });

    const response = await deleteQuery(data);
    return response?.detachPaymentMethod;
  } catch (error) {
    console.log(error);
  }
};

const updatePaymentMethod = async (payment_method_id, input) => {
  try {
    const data = JSON.stringify({
      query: `mutation UpdatePaymentMethod($paymentMethodId: String!, $input: UpdateCardDetailsInput) {
  updatePaymentMethod(payment_method_id: $paymentMethodId, input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        paymentMethodId: payment_method_id,
        input: {
          exp_month: input.exp_month,
          exp_year: input.exp_year,
          name: input.name
        }
      }
    });
    const response = await updateQuery(data);
    return response?.updatePaymentMethod;
  } catch (error) {
    console.log(error);
  }
};

export { attachPaymentMethod, geCustomerPaymentMethods, detachPaymentMethod, updatePaymentMethod };
